"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ClayVerticalNav", {
  enumerable: true,
  get: function get() {
    return _Vertical.ClayVerticalNav;
  }
});
exports.default = void 0;

var _core = require("@clayui/core");

var _Vertical = require("./Vertical");

/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = _core.Nav;
exports.default = _default;